import { FC, memo } from 'react'
import { List, Pagination } from 'antd'
import { ListProps } from 'antd/es/list'
import styles from './index.module.scss'
import { Pagination as PaginationType } from '@/services/apis/BaseModel'
import { WalletItemModel } from '@/services/apis/wallet/models'
import { ReceiveAddressGroupItem } from '@/services/apis/address/models'
import { AddressBookModel } from '@/services/apis/policy/model'
import { DEFAULT_PAGE_SIZE } from '@/constants'
import Empty from '@/components/Empty'
import ShadowView from '@/components/ShadowView'
import { SweepAccount } from '@/services/apis/sweep/models'
import { AutoSweepAddressBookModel } from '@/services/apis/policy/model'

interface PaginationListProps<T> {
  data: PaginationType<T>
  loading: boolean
  current: number
  onChange: (val: number) => void
  renderItem: ListProps<T>['renderItem']
  emptyText?: string
  isShowShadow?: boolean
}

const PaginationList: FC<
  PaginationListProps<
    | WalletItemModel
    | ReceiveAddressGroupItem
    | AddressBookModel
    | SweepAccount
    | AutoSweepAddressBookModel
  >
> = ({ renderItem, data, loading, current, onChange, emptyText, isShowShadow = true }) => {
  const totalPage = data?.totalPages ?? 0
  return (
    <>
      <List
        dataSource={data?.content}
        itemLayout="vertical"
        renderItem={renderItem}
        loading={loading}
        locale={{
          emptyText: (
            <div style={{ marginTop: '100px' }}>
              <Empty text={emptyText} />
            </div>
          ),
        }}
      />

      {isShowShadow && <ShadowView style={{ bottom: totalPage > 1 ? 134 : 100 }} />}
      {totalPage > 1 && (
        <div className={styles.pagination}>
          <Pagination
            current={current}
            total={data?.totalElements}
            pageSize={DEFAULT_PAGE_SIZE}
            showSizeChanger={false}
            onChange={onChange}
          />
        </div>
      )}
    </>
  )
}

export default memo(PaginationList)
